var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMethodDeactivated(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6664_4709)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    cx: 12.5,
    cy: 12.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "inner-circle",
    d: "M15.3753 9.19182L15.8023 8.76061L15.2974 8.42397C14.5053 7.89597 13.5702 7.56 12.5 7.56C9.76386 7.56 7.56 9.76386 7.56 12.5C7.56 13.5719 7.89736 14.5165 8.5 15.32L8.84761 15.7835L9.25527 15.3718L15.3753 9.19182ZM9.62473 15.8082L9.1977 16.2394L9.70265 16.576C10.4947 17.104 11.4298 17.44 12.5 17.44C15.2317 17.44 17.4436 15.239 17.38 12.4939C17.3787 11.4262 17.043 10.4932 16.516 9.70265L16.176 9.19265L15.7447 9.62818L9.62473 15.8082ZM7 12.5C7 9.47614 9.47614 7 12.5 7C15.5239 7 18 9.47614 18 12.5C18 15.5239 15.5239 18 12.5 18C9.47614 18 7 15.5239 7 12.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6664_4709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodDeactivated);
export default __webpack_public_path__ + "static/media/method-deactivated.498218c9ef963fae901e0c77e442b0b6.svg";
export { ForwardRef as ReactComponent };